// extracted by mini-css-extract-plugin
export default {"messageNotification":"Notification_messageNotification__wNkWX","success":"Notification_success__Lkc37","error":"Notification_error__1iidF"};